var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1792,
    height: 1792,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_1",
    d: "m1024,1375l0,-190q0,-14 -9.5,-23.5t-22.5,-9.5l-192,0q-13,0 -22.5,9.5t-9.5,23.5l0,190q0,14 9.5,23.5t22.5,9.5l192,0q13,0 22.5,-9.5t9.5,-23.5zm-2,-374l18,-459q0,-12 -10,-19q-13,-11 -24,-11l-220,0q-11,0 -24,11q-10,7 -10,21l17,457q0,10 10,16.5t24,6.5l185,0q14,0 23.5,-6.5t10.5,-16.5zm-14,-934l768,1408q35,63 -2,126q-17,29 -46.5,46t-63.5,17l-1536,0q-34,0 -63.5,-17t-46.5,-46q-37,-63 -2,-126l768,-1408q17,-31 47,-49t65,-18t65,18t47,49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9bbdb2f304bf3510ffe2505f1db75dc9.svg";
export { ForwardRef as ReactComponent };